import {inject, Injectable} from "@angular/core";
import {KeyStore} from "../stores";
import {KeyTypeEnum} from "../enums";
import {KeyModel} from "../models";

@Injectable({
	providedIn: 'root'
})
export class KeyService {

	private readonly keyStore = inject(KeyStore);

	constructor() {
		this.loadKeys();
	}

	private loadKeys(): void {
		for (const enumKey in KeyTypeEnum) {
			const keyType: KeyTypeEnum = KeyTypeEnum[enumKey as keyof typeof KeyTypeEnum];
			const value = localStorage.getItem(keyType);
			if (value) {
				this.keyStore.saveOrUpdateKey({type: keyType, value: value});
			}
		}
	}

	public saveOrUpdateKey(key: KeyModel): void {
		localStorage.setItem(key.type, key.value);
		this.keyStore.saveOrUpdateKey(key);
	}

	public getKey(keyType: KeyTypeEnum): KeyModel {
		return this.keyStore.getKey(keyType);
	}

	public deleteKey(keyType: KeyTypeEnum): void {
		localStorage.removeItem(keyType);
		this.keyStore.deleteKey(keyType);
	}

}